"use strict";
/* global BaseAPI, moment, Grid, EXIF, proj4 */

/**
 * SOLVNET nous fournit toutes les APIs de base pour l'application
 */
var SOLVNET = {
	isIE: (navigator.userAgent.indexOf('MSIE') >= 0 || navigator.userAgent.indexOf('Trident/') >= 0),
	isIphone: (navigator.userAgent.indexOf('iPhone') >= 0),
	isMobileOrTablet: navigator.userAgent.match(/Android/i) || 
						navigator.userAgent.match(/webOS/i) || 
						navigator.userAgent.match(/iPhone/i) || 
						navigator.userAgent.match(/iPad/i) || 
						navigator.userAgent.match(/iPod/i) || 
						navigator.userAgent.match(/BlackBerry/i) || 
						navigator.userAgent.match(/Windows Phone/i),
	
	navigatorDecimalSeparator: (0.1).toLocaleString().replace(/\d/g, ''),

	// initialisé dans index.jsp
	online: undefined,
	// initialisés via SOLVNET.init
	userId: undefined,
	profileId: undefined,
	cartoAvailable: false,
	bookAvailable: false,
	feedbackAvailable: false,
	tourOptimizerAvailable: false,
	isSuperAdmin: false,
	geoApiEnabled: false,
	geoApiTestEnabled: undefined,
	meansAvailable: false,
	server: false,
	canAccessEXIF: false,

	palettes: {
		Default: '#B3DC10,#F52A26,#6BC8EA,#B3B3B3,#FDD505,#07AA75,#F89833,#4297CD,#6EB961,#B57EA9,#EEEEEE,#669999,#D9E681,#FA6254,#37BCDA,#808080,#FCDE6C,#85D1AE,#F7B268,#73B4E4,#87BB6F,#CE7AAA,#DCDCDC,#A1D8EF,#BAEB57,#FA7E3A,#6699FF,#C0C0C0,#33CC66,#FCEC83',
		Green: '#B3DC10,#07AA75,#6EB961,#D7D7D7,#8FC579,#C0D084,#87B8C4,#CCCCCC,#D9E681,#D7F29F,#52B476,#C0C0C0,#EFED6F,#A3CC7B,#A9BEA1,#B3B3B3,#669999,#BAEB57,#87BB6F,#DCDCDC,#8DBF37,#6EB961,#D7DB35,#999999,#33CC66,#91AD75,#85D1AE,#EEEEEE,#81B763,#D4DE67',
		Pastel: '#D2D4D1,#C2E3E4,#F9EBB4,#DBC4E7,#F6C3B4,#DDEA90,#B8CBE1,#FEBC93,#C3DCAA,#E9B5D8,#F8EB55,#E18F73,#8ECBB3,#E0CF6D,#37BCDA,#FCC997,#8ECCAA,#F1D2DF,#EDEDED,#85A7C4,#D7D394,#B0D3F0,#B1C36E,#FEB36F,#E097B6,#FCF2A9,#CEEBEF,#D5AA9C,#ECE0A5,#B3D48F',
		NewBI: '#CBEB5C,#FF8093,#6BC8EA,#FEEA7A,#07C0A0,#FFBA8C,#FFEDAE,#C3C3C3,#CAECF4,#E1C7B9,#F47A6F,#FC4B51,#518BC1,#93B181,#D3777E',
		Custom: ''
	},

	/**
	 * La méthode suivante retourne un tableau de couleurs CSS extraite de la palette.
	 *
	 * @param {String} palette - la palette qui peut être un noom "Green", "Pastel", "Custom", ... ou une liste sépararée par ","
	 * @param {Object} SETTINGS - la variable globalle "SETTINGS" pour récupérer la palette personnalisée si (palette === "Custom")
	 * @return un tableau de chaine de caractères où chaque entrée en une couleur
	 */
	paletteToColors: function(palette, SETTINGS) {
		if (!palette)
			return null;
		if (palette === 'Custom')
			return SETTINGS.customPalette.split(',');
		if (SOLVNET.palettes[palette])
			return SOLVNET.palettes[palette].split(',');
		return palette.split(',');
	},

	/**
	 * La méthode à appeler depuis la page principale pour initialiser correctement SOLVNET
	 *
	 * @param urlPrefix le préfix (=contexte) pour les URLs
	 */
	init: function(urlPrefix, userId, profileId, cartoAvailable, bookAvailable, feedbackAvailable, tourOptimizerAvailable, isSuperAdmin, meansAvailable, isServer, canAccessEXIF) {
		SOLVNET.urlPrefix = urlPrefix;
		SOLVNET.userId = userId;
		SOLVNET.profileId = profileId;
		SOLVNET.cartoAvailable = cartoAvailable;
		SOLVNET.bookAvailable = bookAvailable;
		SOLVNET.feedbackAvailable = feedbackAvailable;
		SOLVNET.tourOptimizerAvailable = tourOptimizerAvailable;
		SOLVNET.isSuperAdmin = isSuperAdmin;
		SOLVNET.meansAvailable = meansAvailable;
		SOLVNET.server = isServer || false;
		SOLVNET.canAccessEXIF = canAccessEXIF || false;

		if(SOLVNET.isIphone) {
			var patternAllowedCharForNumber = /[\d-]/;
			// On filtre les touches pour la saisie de numérique sur iphone.
			$(document).on("keypress","input[type='number']", function(event) {
				var c =  String.fromCharCode(event.charCode);
				if(event.charCode === 0 || c === SOLVNET.navigatorDecimalSeparator || patternAllowedCharForNumber.test(c)) {
					return;
				}
				event.preventDefault();
			});
		}

		$.ajaxSetup({ cache: false });

		// Configuration des "modal" de Bootstrap pour qu'elle ne se ferment pas quand on clique ailleurs par défaut
		if ($.fn.modal) {
			$.fn.modal.Constructor.DEFAULTS.backdrop = 'static';
		}

		// Configuration du composant Datetimepicker
		if ($.fn.datetimepicker) {
			$.extend($.fn.datetimepicker.defaults.tooltips, SOLVNET.lang.DatetimePicker.tooltips);
		}

		// Configuration du composant Highcharts
		if (window.Highcharts) {
			window.Highcharts.setOptions({
				lang: SOLVNET.getLang('HighchartsLang')
			});
		}

		// Configuration par défaut de la grille
		if ($.fn.grid) {
			Grid.prototype.defaultOptions.bordered = false;
			Grid.prototype.defaultOptions.removeGroupHTML = '<i class="material-icons text-primary">cancel</i>';
			Grid.prototype.defaultOptions.moveToFirstPageHTML = '<i class="material-icons">first_page</i>';
			Grid.prototype.defaultOptions.moveToPreviousPageHTML = '<i class="material-icons">chevron_left</i>';
			Grid.prototype.defaultOptions.moveToNextPageHTML = '<i class="material-icons">chevron_right</i>';
			Grid.prototype.defaultOptions.moveToLastPageHTML = '<i class="material-icons">last_page</i>';
			Grid.prototype.defaultOptions.notReadyHTML = '<i class="material-icons bbm-grid-loading">refresh</i>';
			Grid.prototype.defaultOptions.booleanTrueContent = '<i class="material-icons text-primary">check_box</i>';
			Grid.prototype.defaultOptions.booleanFalseContent = '<i class="material-icons" style="color: rgba(0, 0, 0, .54);">check_box_outline_blank</i>';
			Grid.prototype.defaultOptions.booleanTrueText = SOLVNET.getLang('InputBooleanYes');
			Grid.prototype.defaultOptions.booleanFalseText = SOLVNET.getLang('InputBooleanNo');
			Grid.prototype.defaultOptions.selectionTrueContent = Grid.prototype.defaultOptions.booleanTrueContent;
			Grid.prototype.defaultOptions.selectionFalseContent = Grid.prototype.defaultOptions.booleanFalseContent;
			Grid.prototype.defaultOptions.numberNaNMessage = function(caption) { return SOLVNET.getLang('InputNaNMessage', caption); };
			Grid.prototype.defaultOptions.placeholderColor = '#bbbbbb';
			Grid.prototype.defaultOptions.textColor = '#666666';
			Grid.prototype.defaultOptions.onerror = function(grid, errors, row) { SOLVNET.showErrors(errors); };
		}
	},

	/**
	 * Préfixe pour la construction d'URL, par défaut '/' mais en fait préciser via "SOLVNET.init".
	 */
	urlPrefix: '/',

	/**
	 * Cette fonction retourne une URL complète à partir d'une URL applicative en la préfixant de "SOLVNET.urlPrefix"
	 *
	 * @param baseURL une URL application, par exemple 'app/note'
	 * @param optionnalParams un objet contenant les paramètres à ajouter à l'URL, par exemple {name: 'toto', year: 2015}
	 * @returns {String} une URL complète, par exemple '/bbsolvnet2/app/note?name=toto&year=2015'
	 */
	getURL: function(baseURL, optionnalParams) {
		var s = SOLVNET.urlPrefix + baseURL;
		if (optionnalParams)
			s = s + '?' + $.param(optionnalParams);
		return s;
	},

	/**
	 * Objet clef/valeur servant à la traduction et alimenté via les fichiers "langs/*.js" :
	 * <ul>
	 * <li>par défaut, les traductions se trouvant dans "webapp/langs/en.js"</li>
	 * <li>si précisé, le libellé pour la langue de l'utilisateur (fr ou de)</li>
	 * </ul>
	 */
	lang: {},

	/**
	 * Cette méthode incorpore dans la traduction "lang" les couples (clef, valeur) de "values".
	 * Le principe général est de faire : $.extend(SOLVNET.lang, values);
	 * Toutefois, le code de vérification des fichiers de traduction peut facilement être activé.
	 */
	addLang: function(lang, values) {
		/*
		var errors = 0, compare = function(path, reference, tested) {
			var missing = [];
			for (var p in reference) {
				var r = reference[p], t = tested[p];
				if (!t)
					missing.push(p);
				if (typeof r === 'object') {
					compare(path + p + '/', r, t);
				}
			}
			if (missing.length > 0) {
				console.log('[' + lang + '] Clefs manquantes dans ' + path, missing);
				errors += missing.length;
			}
		};

		if (lang !== 'en') {
			compare('/', SOLVNET.lang, values);
			console.log('[' + lang + '] ' + errors + ' erreur(s) de traduction');
			if (errors > 0)
				alert('[' + lang + '] ' + errors + ' erreurs de traduction');
		}
		*/
		$.extend(SOLVNET.lang, values);
	},

	/**
	 * Cette fonction traduit la clef donnée dans la langue en cours.
	 * Si la clef est suivi de paramètres ou d'un tableau de paramètre, elle formattera le message en appelant SOLVNET.formatMessage
	 *
	 * Par exemple, si la traduction initialise :
	 * <pre>
	 * SOLVNET.lang['Message'] = 'Coucou';
	 * SOLVNET.lang['Hello'] = 'Bonjour {1}, {2} fois';
	 * </pre>
	 *
	 * <ul>
	 * <li>L'appel SOLVNET.getLang('Message') retournera 'Coucou'</li>
	 * <li>L'appel SOLVNET.getLang('Hello', 'Invité', 3) retournera 'Bonjour Invité, 3 fois'</li>
	 * <li>L'appel SOLVNET.getLang('Hello', ['Invité', 3]) retournera aussi 'Bonjour Invité, 3 fois'</li>
	 * </ul>
	 *
	 * @param key la clef à traduire, éventuellement suivie de paramètres
	 * @returns la traduction de la clef, en substituant, les paramètres {1}, {2}, ... avec ce qui suit 'key'
	 */
	getLang: function(key) {
		// special case of number and the number is 0 in resources (for exemple: firstDayOfWeek key)
		// https://helpdesk.geoconcept.com/issues/152843
		if(SOLVNET.lang[key] === 0){
			return SOLVNET.lang[key];
		}

		var text = SOLVNET.lang[key] || key;
		if (arguments.length > 1) {
			var isArray = $.isArray(arguments[1]),
				params = isArray ? arguments[1] : Array.prototype.slice.call(arguments, 1, arguments.length);
			text = SOLVNET.formatMessage(text, params);
		}
		return text;
	},

	/**
	 * Cette fonction formatte un message en substituant {0}, {1}, ... par les paramètres à la suite de "text"
	 *
	 * Par exemple,
	 * <pre>
	 * SOLVNET.formatMessage('Bonjour {0}, {1} fois', 'Invité', 3)
	 * SOLVNET.formatMessage('Bonjour {0}, {1} fois', ['Invité', 3])
	 * </pre>
	 * retourneront tous les deux <code>'Bonjour Invité, 3 fois'</code>
	 *
	 * @param text le message à formatter, contenant des {0}, {1}, ...
	 * @returns le message formatté, en substituant {0}, {1}, ... par les paramètres à la suite de "text"
	 */
	formatMessage: function(text) {
		if (arguments.length > 1) {
			// Quand on appelle formatMessage('...', param1, param2, ...), on itère "arguments" à partir de 1
			// Quand on appelle formatMessage('...', [param1, param2, ...]), on itère "arguments[1]" à partir de 0
			var isArray = $.isArray(arguments[1]),
				params = isArray ? arguments[1] : arguments,
				offset = isArray ? 0 : 1;
			for (var i = offset; i < params.length; i++) {
				text = text.replace('{' + (i - offset) + '}', params[i]);
			}
		}
		return text;
	},

	/** Cette méthode affiche une liste d'erreurs à l'utilisateur */
	showErrors: function(errors) {
		errors.forEach(SOLVNET.showError);
	},

	/** Cette méthode affiche un message d'erreur à l'utilisateur */
	showError: function(message) {
		SOLVNET.showMessage(message, true, 0);
	},

	/** Cette méthode affiche un message de réussite à l'utilisateur */
	showSuccess: function(message) {
		SOLVNET.showMessage(message, false, 4000);
	},

	/**
	 * Cette méthode affiche un message à l'utilisateur, avec possibilité d'activer un bouton à droite
	 */
	showMessage: function(message, error, duration, details, button, callback) {
		var snackbar = {
			message: message,
			error: !!error,
			duration: duration
		};
		if (details)
			snackbar.details = details;
		if (button)
			snackbar.button = button;
		if (callback)
			snackbar.callback = callback;
		$.materialSnackbar(snackbar);
	},

	/**
	 * Cette méthode indique au serveur le type de périphérique de l'utilisateur
	 * @param : force : permet définir si il faut quand meme faire la verification du materiel sur lequel la page va être affichée. https://support.solvnet.fr:9998/devels/edit/4333
	 */
	registerDevice: function(force) {
		var registerCalledWhileOffline = false;
		var registerDeviceTimeout = null;
		function registerDeviceInfo() {
			// En mode hybride, le serveur n'est pas accessible donc on zappe l'appel.
			// Toutefois, on note ce point pour lancer le "GET" quand on récupère l'accès.
			if (! force && ! SOLVNET.online) {
				registerCalledWhileOffline = true;
				return;
			}
			$.get(SOLVNET.getURL('layout/device'), {
				width: window.innerWidth,
				height: window.innerHeight,
				pixelRatio: Math.round(window.devicePixelRatio * 100),
				touchEnabled: ('ontouchstart' in document.body)
			});
		}
		// Appeler une fois au chargement de la page
		registerDeviceInfo();
		// Appeler en cas de redimensionnement de la page (acvec timeout pour éviter de surcharger d'appels)
		$(window).on('resize', function() {
			if (registerDeviceTimeout)
				clearTimeout(registerDeviceTimeout);
			registerDeviceTimeout = setTimeout(function() {
				if (registerDeviceTimeout !== null) {
					registerDeviceTimeout = null;
					registerDeviceInfo();
				}
			}, 200);
		});
		// Appeler quand on récupère l'accès au serveur, si un appel a été bloqué en mode hybride
		$(window).on('solvnet.onlinechange', function() {
			if (SOLVNET.online && registerCalledWhileOffline) {
				registerCalledWhileOffline = false;
				registerDeviceInfo();
			}
		});
	},

	/**
	 * Cette méthode affiche le message donné à l'utilisateur afin de lui demander confirmation.
	 * Si l'utilisateur confirme, la fonction donnée est appelée.
	 *
	 * Les différences notables avec "window.confirm" sont :
	 * - le comportement est asynchrone
	 * - l'utilisateur ne pourra pas par erreur demander à masquer les messages
	 * - les actions "dangereuses" sont mises en évidence grâce à "danger=true"
	 *
	 * @param {boolean} danger - indique si l'action est dangereuse (true) ou non (false)
	 * @param {boolean} html - indique si le message est en HTML (true) ou en texte brut (false)
	 * @param {String} message - le message de confirmation à afficher
	 * @param {function} callbackConfirm - la fonction sans paramètre à appeler si l'utilisateur confirme
	 * @param {function} callbackCancel - la fonction sans paramètre à appeler si l'utilisateur annule
	 * @param {function} callbackResult - la fonction qui prendra en paramètre un boolean, true si confirmé, false si annulé
	 */
	confirm: function(danger, html, message, callbackConfirm, callbackCancel, callbackResult) {
		// On récupère la fenêtre de confirmation
		var dialog = $('#confirm-dialog');
		// Si elle n'existe pas (dans quel cas à part index.jsp ?), on utilise "window.confirm" à la place
		if (dialog.length === 0) {
			var confirmed = window.confirm(message);
			if (confirmed && callbackConfirm)
				callbackConfirm();
			if (!confirmed && callbackCancel)
				callbackCancel();
			if (callbackResult)
				callbackResult(confirmed);
		} else {
			// Sinon, on affiche le message avec l'importance demandée dans la fenêtre de confirmation
			var modal = dialog.find('.modal-body');
			if (html === true)
				modal.html(message);
			else
				modal.text(message);
			modal.toggleClass('text-danger', danger);
			// On récupère le bouton de confirmation pour lui donner l'importance demandée et attendre un clic
			dialog.find('#confirm-button').toggleClass('btn-danger', danger).toggleClass('btn-primary', !danger).off('click').on('click', function() {
				if (callbackConfirm)
					callbackConfirm();
				if (callbackResult)
					callbackResult(true);
				dialog.modal('hide');
			});
			// On écoute également le click sur le bouton cancel
			dialog.find('#cancel-button').off('click').on('click', function() {
				if (callbackCancel)
					callbackCancel();
				if (callbackResult)
					callbackResult(false);
				dialog.modal('hide');
			});

			// On peut afficher la demande de confirmation
			dialog.modal('show');
		}
	},

	/**
	 * Cette méthode affiche la fenêtre modale de modification de la note utilisateur.
	 */
	showNote: function() {
		$('#note-dialog').modal('show');
	},

	/**
	 * Cette méthode indique la page en cours dans l'onglet du navigateur ainsi que dans la barre supérieure
	 */
	showLocation: function(title) {
		var t = $('title');
		if (! t.attr('data-default-title'))
			t.attr('data-default-title', t.text());
		title = title || t.attr('data-default-title');
		$('#index-location').text(title);
		t.text(title);
	},

	/**
	 * Cette méthode demande l'affichage de l'URL donnée :
	 * - la navigation actuelle remplacera la page en cours par l'URL demandée
	 * - si on intégrait un navigation par onglet, on ouvrirait un onglet pour cette URL
	 * - si on souhaitait en plus que l'onglet soit unique, on rechercherait si l'URL est déjà ouverte avec d'ouvrir un nouvelle onglet
	 */
	showPage: function(url) {
		window.location = url;
	},

	/**
	 * Cette méthode permet au code JavaScript de remonter des traces côté serveur pour qu'ils apparaissent dans les logs récupérables par le support.
	 *
	 * @param {String} level - le niveau de log, parmi "fatal", "error", "warn", "info", "debug", "trace"
	 * @param {String} message - le message à tracer
	 * @param {Function} done - la fonction facultative à appeler quand c'est fait, peut importe le résultat
	 *
	 * @see Utiliser si besoin SOLVNET.formatMessage pour formatter un message avec paramètre(s)
	 */
	log: function(level, message, done) {
		var post = $.post(SOLVNET.getURL('app/log'), {
			level: level,
			message: message
		});
		if (typeof done === 'function')
			post.always(done);
	},

	/**
	 * Cette méthode :
	 * - récupère le paramétrage des mails (mail/settings?...)
	 * - utilise une lien "mailto:" si les mails ne sont pas actifs dans SOLVNet
	 * - s'assure que CKEDITOR est chargé (SOLVNET.initCKEditor)
	 * - affiche ensuite le popin de saisie de mail ($.fn.materialPopinMail)
	 * - envoie enfin le mail quand l'utilisateur valide (SOLVNET.sendMail).
	 */
	openMail: function(model, objectId, marketId, customerId, configurationId, mailDatas) {
		mailDatas = mailDatas || {addSignature: true};
		// Récupérer les infos (mails de l'utilisateur, contacts de customerId et template de objectId)
		var defer = $.Deferred().resolve('Go');
		var canModify = mailDatas.canModify === undefined || !!mailDatas.canModify;
		if (canModify)
			defer = defer.then(function() {
				return $.get(SOLVNET.getURL('mail/settings', {
					modelName: model,
					customerId: customerId,
					marketId: marketId,
					objectId: objectId,
					configurationId: configurationId
				}));
			});
		defer.then(function(data) {
			if (!data.mailAvailable && canModify) {
				// On utilise un lien "mailto:" quand la messagerie n'est pas accessible par SOLVNet
				var separator = '',
					mailtoCmd = 'mailto:';
				mailtoCmd += encodeURIComponent(mailDatas.sendTo || '');
				if (mailDatas.subject || mailDatas.content)
					mailtoCmd += '?';
				if (mailDatas.subject) {
					mailtoCmd += separator + 'subject=' + encodeURIComponent(mailDatas.subject);
					separator = '&';
				}
				if (mailDatas.content) {
					mailtoCmd += separator + 'body=' + encodeURIComponent(mailDatas.content);
					separator = '&';
				}
				// à compléter si d'autres option à prendre en compte
				window.open(mailtoCmd , '_self');
				return;
			}
			// S'assurer que CKEDITOR est chargé
			SOLVNET.initCKEditor().then(function() {
				var signature = data.froms && data.froms[0].signature;
				if (signature && mailDatas.addSignature && !(data.forceSignature))
					mailDatas.content = (mailDatas.content ? mailDatas.content : '') + '<br />' + signature;

				// Ouvrir le popin pour la saisie de mail
				$('<div />').materialPopinMail({
					lang: SOLVNET.getLang('Locale'),
					froms: data.froms,
					contacts: data.contacts,
					sendTo: mailDatas.sendTo || '',
					sendToMaxLength: 512, //MySQL varchar(512)
					sendCC: mailDatas.sendCc || '',
					sendCCMaxLength: 512, //MySQL varchar(512)
					sendBCC: (data.addBccOwnerEmail ? data.froms[0].email : (!canModify ? mailDatas.sendBcc : '')),
					sendBCCMaxLength: 512, //MySQL varchar(512)
					replyTo: mailDatas.replyTo || '',
					replyToMaxLength: 512, //MySQL varchar(512)
					subject: mailDatas.subject || '',
					subjectMaxLength: 128, //MySQL varchar(128)
					content: mailDatas.content || '',
					contentMaxLength: 16777215, //MySQL MEDIUMTEXT
					attachments: data.attachments,
					error: SOLVNET.showError,
					addSignature: mailDatas.addSignature && data.forceSignature,
					execute: function(mail) {
						// Envoyer le mail par SOLVNet quand l'utilisateur valide l'envoi
						return SOLVNET.sendMail(mail, model, objectId, marketId, customerId, configurationId);
					},
					onaddContacts: function(contacts) {
						function addField(infoName, property, defaultCaption) {
							if (data.fieldsRights[infoName] && !!data.fieldsRights[infoName].visible)
								fields.push({
									property: property,
									caption: data.fieldsRights[infoName].caption || defaultCaption
								});
						}

						var def = $.Deferred();
						var fields = [
							{property: 'caption', caption: SOLVNET.getLang('ContactCaption')}
						];
						addField('contacts.email', 'email', SOLVNET.getLang('ContactEmail'));
						addField('contacts.function_id', 'function', SOLVNET.getLang('ContactFunctionId'));
						addField('contacts.department_ids', 'departments', SOLVNET.getLang('ContactDepartmentIds'));
						$('<div />').materialPopinSelectContact(contacts, fields, function(selectedContacts) {
							def.resolve(selectedContacts);
						}, function() {
							def.reject();
						});
						return def;
					},
					canModify: canModify,
					canSendMail: mailDatas.canSendMail,
				});
			});
		});
	},

	/**
	 * Cette méthode envoie au serveur le contenu d'un mail "mail", en indiquant à quelle donnée le rattacher
	 * (model, objectId) et le contexte (marketId, customerId) et retourne le "Deferred" de l'appel à  $.axax.
	 *
	 * @param mail - le mail à envoyer, tel que fournit par materialPopinMail
	 * @param model - le type de donnée à laquelle le mail est attaché (cf ECommonMailModel)
	 * @param objectId - l'identifiant de la donnée à laquelle le mail est attaché (client, linéaire, ...)
	 * @param marketId - le marché en cours, auquel le mail sera rattaché
	 * @param customerId - l'identifiant du client (pour connaitre les contacts)
	 * @param configurationId - l'identifiant de la configuration (pour appliquer les filtres sur la configuration)
	 * @return un Deferred obtenu suite à l'appel à $.ajax
	 */
	sendMail: function(mail, model, objectId, marketId, customerId, configurationId) {
		var attachmentIndex = 0;
		var formData = new FormData();
		formData.append('form.model', model);
		formData.append('form.objectId', objectId);
		formData.append('form.marketId', marketId);
		formData.append('form.customerId', customerId);
		formData.append('form.configurationId', configurationId);
		formData.append('form.contentIsHTML', mail.contentIsHTML === false ? false : true);
		['from', 'sendTo', 'sendCC', 'sendBCC', 'replyTo', 'subject', 'content'].forEach(function(field) {
			if (mail[field])
				formData.append('form.' + field, mail[field]);
		});
		if (mail.files) {
			mail.files.forEach(function(file) {
				var prefix = 'form.attachments.attachment' + (++attachmentIndex) + '.';
				formData.append(prefix + 'type', 'upload');
				formData.append(prefix + 'uploadFile', file);
			});
		}
		if (mail.attachments) {
			mail.attachments.forEach(function(attachment) {
				var prefix = 'form.attachments.attachment' + (++attachmentIndex) + '.';
				formData.append(prefix + 'type', attachment.type);
				if (attachment.type === 'attachment')
					formData.append(prefix + 'attachmentId', attachment.attachmentId);
				else //if (attachment.type === 'template')
					formData.append(prefix + 'templateName', attachment.templateName);
			});
		}
		return $.ajax({
			url: SOLVNET.getURL('mail/send'),
			type: 'POST',
			contentType: false, // enverra bien (1) en multipart/form-data, (2) en UTF-8 et (3) avec un "boundary" correctement défini
			processData: false,
			data: formData
		}).then(undefined, function(error) {
			return $.Deferred().reject(error.responseText);
		});
	},
	initCKEditor: function() {
		if ('CKEDITOR' in window)
			return $.Deferred().resolve();

		// La variable globale à positionner AVANT le chargement de "ckeditor.js" pour indiquer à
		// CKEDITOR où aller chercher les fichiers de config, de skins, de langues et de plugins.
		window.CKEDITOR_BASEPATH = SOLVNET.getURL('libs/ckeditor/');

		// Chargement à la volée de CKEditor
		return $.ajax({
			dataType: 'script',
			cache: true,
			url: SOLVNET.getURL('libs/ckeditor/ckeditor.js')
		}).then(function() {
			// "defaultLanguage" n'est utilisé que si la langue du navigateur n'est pas reconnue
			// window.CKEDITOR.config.defaultLanguage = language || 'fr';
			// "language" définit la lanque par défaut indépendament de la langue du navigateur
			window.CKEDITOR.config.language = SOLVNET.getLang('Locale') || 'fr';
	
			// Personnalisation de CKEditor, notamment le bouton "Plus..."
			BaseAPI.ckeditorInit(SOLVNET.getLang('CKEditorMoreButtonLabel'));
		});
	},
	initSharePage: function(notification, message, sendMail, sendBccMail, userIds) {
		var context = $('#share-button').data('context'),
			section = $('#share-button').data('section'),
			page =  $('#share-button').data('page'),
			urlContext = {marketId: context.marketId},
			dynamicContext = {};

		for (var p in context) {
			if (context.saveProperties.indexOf(p) >= 0) {
				if (section.queryContextProperties.indexOf(p) >= 0)
					urlContext[p] = context[p];
				else
					dynamicContext[p] = context[p];
			}
		}

		notification.message = message;
		notification.sendMail = sendMail;
		notification.sendBccMail = sendBccMail;
		notification.userIds = userIds;
		notification.data = JSON.stringify({
			pageId: page.id,
			pageCaption: page.caption,
			urlContext: urlContext,
			dynamicContext: dynamicContext
		});
		notification.origin = window.location.origin;
	},
	getCartoAvailable: function() {return SOLVNET.cartoAvailable;},
	getBookAvailable: function() {return SOLVNET.bookAvailable;},
	getFeedbackAvailable: function() {return SOLVNET.feedbackAvailable;},
	getTourOptimizerAvailable: function() {return SOLVNET.tourOptimizerAvailable;},
	getGeoAPIAvailable: function() { return SOLVNET.geoApiEnabled; },
	getGeoApiTestEnabled: function() { return SOLVNET.geoApiTestEnabled; },
	getMeansAvailable: function() {return SOLVNET.meansAvailable;},
	isServer: () => SOLVNET.server,
	isClient: () => !SOLVNET.isServer(),

	/**
	 * Gestion des actions "onbuild" saisies éventuellement lors de la configuration des LayoutItem.
	 * Les fonctions disponibles sont définies dans "loadLayoutActions", qui se trouve dans "layout.js".
	 */
	onbuild: {},
	/**
	 * Gestion des actions "onclick" saisies éventuellement lors de la configuration des LayoutItem.
	 * Les fonctions disponibles sont définies dans "loadLayoutActions", qui se trouve dans "layout.js".
	 */
	onclick: {}
};

/**
 * UTILS nous fournit un ensemble de fonction utiles, regroupées par dommain, par exemple avec UTILS.array.*
 */
var UTILS = {
	functions: {
		identity: function(a) { return a; },
		allTrue: function() { return true; },
		allFalse: function() { return false; },
		todo: function() { throw new Error('TODO'); },
		empty: function() {},
		autoselectonfocus: function(event) {
			/* 
			 * Les input de type 'email' ne supportent pas selectionStart.
			 * On peut tricher en changeant temporairement le type de l'input.
			 * https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/setSelectionRange
			 */
			var hasEmailType = 'email' === $(event.target).attr('type');
			if (hasEmailType)
				$(event.target).attr('type', 'text');
			event.target.selectionStart = 0; event.target.selectionEnd = event.target.value.length;
			if (hasEmailType)
				$(event.target).attr('type', 'email');
		},
		escapeDirtyText: function(event) { // Voir la fonction homonyme dans XMLUtils.java
			function isForbiddenCharacter(c) {
				if (c === '\t'.charCodeAt() || c === '\n'.charCodeAt() || c === '\r'.charCodeAt()) // 0x9 0xa 0xd
					return false;
				if (c < '\u0020'.charCodeAt() || c === '\uFFFE'.charCodeAt() || c === '\uFFFF'.charCodeAt())
					return true;
				if (c > '\uD7FF'.charCodeAt() && c < '\uE000'.charCodeAt())
					return true;
				return false;
			}

			let val = (event.clipboardData || window.clipboardData).getData('text');
			if (!!val) {
				// Parcourir la chaine de gauche à droite
				let position = 0;
				// Utiliser 'remaining' pour nettoyer au fur et à mesure la partie gauche déjà traitée
				let remaining = val;
				// Utiliser 'keep' pour les parties à conserver
				let keep = "";
				while (position < remaining.length) {
					let c = remaining.charCodeAt(position);
					if (isForbiddenCharacter(c)) {
						// Quand on tombe sur un caractère
						if (position > 0)
							keep += remaining.substring(0, position);
						remaining = remaining.substring(position + 1);
						position = 0;
					} else {
						position++;
					}
				}
				// Si on a eu des modification du texte alors on les appliques à
				if (remaining.length !== val.length) {
					if (remaining.length > 0)
						keep += remaining;
					$(event.target).val(keep);
				} else {
					$(event.target).val(val);
				}
				event.preventDefault();
			}
		}
	},
	number: {
		between: BaseAPI.numberBetween,
		max: function(array, property) {
			return UTILS.number.mathFunction(array, property, 'max', Number.NEGATIVE_INFINITY);
		},
		min: function(array, property) {
			return UTILS.number.mathFunction(array, property, 'min', Number.POSITIVE_INFINITY);
		},
		mathFunction: function(array, property, functionName, initialValue) {
			if (array.length === 0)
				return null;
			return array.reduce(function(currentValue, entry) {
				return Math[functionName](currentValue, property ? entry[property] : entry);
			}, initialValue);
		},
		trunc : function(v) {
			return v >= 0 ? Math.floor(v) : Math.ceil(v);
		}
	},
	object: {
		/**
		 * Cette méthode retourne true si "a" et "b" peuvent être considérés identiques :
		 * - null / null
		 * - 2 nombres dont la différence est minime (< 0.0001)
		 * - 2 objets strictement égaux par '==='
		 */
		equalsOrEquivalentNumbers: function(a, b) {
			if (a === null)
				return b === null;
			if (typeof a === 'number')
				return (typeof b === 'number') && (Math.abs(a - b) < 0.0001);
			return a === b;
		},
		/**
		 * Cette méthode extraite du "moment.js" renvoie true si l'objet passé en paramètre est un objet de "Moment"
		 */
		isMoment: function(obj) {
			return obj instanceof moment || (obj != null && obj._isAMomentObject != null);
		},
		/**
		 * Cette méthode est l'équivalent de IDataType.compare, utilisée par exemple dans les aggrégateurs
		 */
		compare: function(value1, value2) {
			// Gestion des null
			if ((value1 === null) && (value2 === null))
				return 0;
			if (value1 === null)
				return -1;
			if (value2 === null)
				return 1;
			// Transformation des objets Moment.js en entier comparable
			// TODO : a priori pas utile d'après Mozilla (les opérateurs < <= >= et > appellent eux-mêmes valueOf())
			// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Comparison_Operators#Relational_operators
			if (UTILS.object.isMoment(value1)) {
				value1 = value1.valueOf();
				value2 = value2.valueOf();
			}
			// Renvoyer -1, 0 ou 1 selon les cas
			return (value1 < value2) ? -1 : (value1 > value2) ? 1 : 0;
		},
		/**
		 * Cette méthode vide les propriétés de "obj" et renvoie "obj" pour pouvoir chainer.
		 * Par exemple : UTILS.object.reset({ foo: 'bar', toto: null}) renvoie l'équivalent de {}
		 */
		reset: function(obj) {
			for (var p in obj) {
				if (obj.hasOwnProperty(p))
					delete obj[p];
			}
			return obj;
		},
		/**
		 * Cette méthode copie dans "dst" les propriétés "propertyNames" extraites de l'objet "src" et renvoie "dst".
		 * Par exemple : UTILS.object.inject({}, context, ['marketId', 'customerId'])
		 */
		inject: function(dst, src, propertyNames) {
			propertyNames.forEach(function(name) {
				dst[name] = src[name];
			});
			return dst;
		},
		/**
		 * Cette méthode crée un object composé des propriétés "propertyNames" extraites de l'objet "src"
		 * Par exemple : UTILS.object.extract(context, ['marketId', 'customerId'])
		 * Equivalent à : UTILS.object.inject({}, context, ['marketId', 'customerId']);
		 */
		extract: function(src, propertyNames) {
			return UTILS.object.inject({}, src, propertyNames);
		},
		/**
		 * Cette méthode remplace tout le contenu de "dst" par le contenu de "src" et renvoie "dst".
		 * Permet de récupérer un object côté serveur et de l'injecter dans l'objet côté client en gardant la même référence
		 * Par exemple : $.post('...', {customer: row}).done(function(newCustomer) { UTILS.object.replace(row, newCustomer); });
		 */
		replace: function(dst, src) {
			UTILS.object.reset(dst); // on vide
			$.extend(dst, src); // avant de remplir
			return dst;
		},
		/**
		 * Cette méthode clone un objet sans ses fonctions  (contrairement à $.extend). Elle opère aussi sur les sous propriété.
		 * Ce type de transformation est nécessaire pour des sérialisations d'objet en formulaire par JQuery
		 * Ce dernier va jusqu'à appeler les méthodes public des objets mais sans le contexte "this" approprié de l'objet.
		 */
		cloneProperties: function(dst, src) {
			function cloneArray(arraySrc) {
				return arraySrc.map(function(s) {
					if(typeof s === 'string' || typeof s === 'number')
						return s;
					else if(s  instanceof Array)
						return cloneArray(s);

					// Object
					return UTILS.object.cloneProperties({}, s);
				});
			}

			for (var p in src) {
				if (src.hasOwnProperty(p) && typeof src[p] !== 'function') {
					if(src[p] instanceof Array) {
						dst[p] = cloneArray(src[p]);
					} else if(src[p] instanceof Object) {
						dst[p] = UTILS.object.cloneProperties({}, src[p]);
					} else {
						dst[p] = src[p];
					}
				}
			}
			return dst;
		},
		/**
		 * Cette méthode renvoie la valeur d'"object" associée à la clé "key" si elle existe ou lui associe la valeur "defaultValue"
		 * avant de la retourner si elle n'existe pas
		 */
		computeIfAbsent: function(object, key, defaultValue) {
			if (object[key] === undefined)
				object[key] = defaultValue;
			return object[key];
		},
		/**
		 * Cette méthode renvoie true si la valeur n'est pas undefined, pas null et pas égale à false. False sinon
		 */
		isDefinedNotNullNotFalse: function(obj) {
			return ! (obj === undefined || obj === null || obj === false);
		}
	},
	subObjectProperty: {
		/** Cette méthode ajuste tous les champs de "fields" en les décalant dans un sous objet via "subObjectProperty" */
		setOnFields: function(fields, subObjectProperty) {
			fields.forEach(function(field) {
				if (field.subObjectProperty) {
					field.subObjectProperty = subObjectProperty + "." + field.subObjectProperty;
				} else {
					field.subObjectProperty = subObjectProperty;
				}
			});
		},
		/**
		 * Cette méthode retourne la propriété "subObjectProperty" de l'objet "src" et, si absent, y injecte un nouvel objet :
		 * - "subObjectProperty" ne peut pas être vide
		 * - "subObjectProperty" ne peut pas contenir un chemin (voir "transform" pour utiliser un chemin)
		 * - si "row[subObjectProperty]" n'existe pas, un objet vide est créé et injecter
		 */
		get: function (src, subObjectProperty) {
			var result = src[subObjectProperty];
			if (! result) {
				result = {};
				src[subObjectProperty] = result;
			}
			return result;
		},
		/**
		 * Cette méthode applique le comportement de "subObjectProperty" à un objet "row" pour obtenir l'objet souhaité :
		 * - si "subObjectProperty" est vide, on retourne "row"
		 * - si "subObjectProperty" est "calculatedInformation", on retourne "row['calculatedInformation']"
		 * - si "subObjectProperty" est "customer.calculatedInformation", on retourne "row['customer']['calculatedInformation']"
		 */
		transform: function(row, subObjectProperty) {
			var self = this;
			// Si 'subObjectProperty' n'est pas définie, on retourne row
			if (!subObjectProperty)
				return row;
			// Le plus souvent, 'subObjectProperty' est le nom d'un sous-objet de 'row'
			// contenant les valeurs de la colonne (par exemple 'extendedInformation')
			if (subObjectProperty.indexOf('.') === -1)
				return self.get(row, subObjectProperty);
			// Toutefois, si 'subObjectProperty' peut représenter un chemin (par exemple
			// 'customer.extendedInformation'), la transformation est un peu + complexe
			subObjectProperty = subObjectProperty.split('.');
			var result = row;
			for (var i = 0; i < subObjectProperty.length; i++) {
				result = self.get(result, subObjectProperty[i]);
			}
			return result;
		},
		/**
		 * Cette méthode applique le comportement de "subObjectProperty" et retourne une fonction de transofmration (row)=>objet souhaité
		 * - si "subObjectProperty" est vide, on retourne une fonction (row)->row
		 * - si "subObjectProperty" est "calculatedInformation", on retourne une fonction (row)->row['calculatedInformation']
		 * - si "subObjectProperty" est "customer.calculatedInformation", on retourne une fonction (row)->row['customer']['calculatedInformation']
		 */
		transformMethod: function(subObjectProperty) {
			var self = this;
			// Si 'subObjectProperty' n'est pas définie, on retourne row
			if (!subObjectProperty)
				return UTILS.functions.identity;
			// Le plus souvent, 'subObjectProperty' est le nom d'un sous-objet de 'row'
			// contenant les valeurs de la colonne (par exemple 'extendedInformation')
			if (subObjectProperty.indexOf('.') === -1)
				return function(row) { return self.get(row, subObjectProperty); };
			// Toutefois, si 'subObjectProperty' peut représenter un chemin (par exemple
			// 'customer.extendedInformation'), la transformation est un peu + complexe
			subObjectProperty = subObjectProperty.split('.');
			return function(row) {
				var result = row;
				for (var i = 0; i < subObjectProperty.length; i++) {
					result = self.get(result, subObjectProperty[i]);
				}
				return result;
			};
		},
	},
	string: {
		fileExtension: BaseAPI.stringFileExtension,
		toTimeMS: function(s, momentFormat) {
			return s ? moment(s, momentFormat).valueOf() : undefined;
		},
		isEmpty: function(s) {
			return s === undefined || s === null || s.length === 0 || (s.trim().length === 0);
		},
		addLeadingZero: function(number, integerPartLength) {
			let result = '' + number;
			
			if (number === 0) { // Cas particulier 
				const max = integerPartLength - 1;
				for (let i = 0; i < max; i++) {
					result = '0' + result;
				}
				return result;
			}
			const limit = Math.pow(10, integerPartLength - 1);
			while (number < limit) {
				result = '0' + result;
				number *= 10;
			}
			return result;
		}
	},
	array: {
		addIfNotFound: function(array, o) {
			// Search item
			var found = array.some(function(item) {
				return UTILS.object.compare(item, o) === 0;
			});
			// Filter dupplicates
			if (!found)
				array.push(o);
		},
		remove: BaseAPI.arrayRemove,
		mapByIn: function(result, array, property) {
			array.forEach(function(value) {
				result[value[property]] = value;
			});
			return result;
		},

		mapBy: function(array, property) {
			return UTILS.array.mapByIn({}, array, property);
		},
		containsBy: function(array, property, value) {
			return -1 !== UTILS.array.findIndexBy(array, property, value);
		},
		findBy: function(array, property, value) {
			var index = UTILS.array.findIndexBy(array, property, value);
			return index === -1 ? undefined : array[index];
		},
		findByValues: function(array, property, values) {
			return values.map(function(value) {
				return UTILS.array.findBy(array, property, value);
			});
		},
		findIndexBy: function(array, property, value) {
			return array.findIndex(function(e) { return e[property] === value; });
		},
		sortBy : function(array, property, extraProperty) {
			function compare(a,b) {
				var p;
				if (a[property] < b[property])
					return -1;
				if (a[property] > b[property])
					return 1;

				if(extraProperty !== undefined) {
					for(var x=2;x < arguments.length;x++) {
						p = arguments[x];
						if (a[p] < b[p])
							return -1;
						if (a[p] > b[p])
							return 1;
					}
				}
				return 0;
			}
			array.sort(compare);
			return array;
		},
		removeBy: function(array, property, value) {
			var index = UTILS.array.findIndexBy(array, property, value);
			if (index >= 0)
				array.splice(index, 1);
			return array;
		},

		mapByName: function(array) {
			return UTILS.array.mapBy(array, 'name');
		},
		containsByName: function(array, name) {
			return UTILS.array.containsBy(array, 'name', name);
		},
		findByName: function(array, name) {
			return UTILS.array.findBy(array, 'name', name);
		},
		findByNames: function(array, names) {
			return UTILS.array.findByValues(array, 'name', names);
		},
		findIndexByName: function(array, name) {
			return UTILS.array.findIndexBy(array, 'name', name);
		},
		sortByName : function(array) {
			return UTILS.array.sortBy(array, 'name');
		},
		removeByName: function(array, name) {
			return UTILS.array.removeBy(array, 'name', name);
		},

		mapById: function(array) {
			return UTILS.array.mapBy(array, 'id');
		},
		containsById: function(array, id) {
			return UTILS.array.containsBy(array, 'id', id);
		},
		findById: function(array, id) {
			return UTILS.array.findBy(array, 'id', id);
		},
		findByIds: function(array, ids) {
			return UTILS.array.findByValues(array, 'id', ids);
		},
		findIndexById: function(array, id) {
			return UTILS.array.findIndexBy(array, 'id', id);
		},
		sortById : function(array) {
			return UTILS.array.sortBy(array, 'id');
		},
		removeById: function(array, id) {
			return UTILS.array.removeBy(array, 'id', id);
		},
		equals: function (a1, a2) {
			var res =
				a1.length === a2.length
				&&
				a1.every(function(value, index) {
					return value === a2[index];
				});
			return res;
		},
		// Renvoie les arguments sous forme de tableau, en éclatant les arguments qui sont eux-mêmes des tableaux
		// flatConcat(1, [2, 3, 4], 5, [6, 7]) renverra [1, 2, 3, 4, 5, 6, 7]
		flatConcat: function() {
			if (arguments.length === 0)
				return [];
			if (arguments.length === 1)
				return $.isArray(arguments[0]) ? arguments[0] : [arguments[0]];
			var r = [];
			for (var i = 0; i < arguments.length; i++) {
				if ($.isArray(arguments[i]))
					r = r.concat(arguments[i]);
				else
					r.push(arguments[i]);
			}
			return r;
		},
		groupBy: function(list, keyGetter) {
			const map = new Map();
			list.forEach((item) => {
				const key = keyGetter(item);
				const collection = map.get(key);
				if (!collection) {
					map.set(key, [item]);
				} 
				else {
					collection.push(item);
				}
			});
			return map;
		}
	},
	datetime : {
		weekdays: ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'],
		formatInternal: function(date) {
			return moment(date).format('YYYY/MM/DD HH:mm:ss');
		},
		parseInternal: function(stringDate) {
			return moment(stringDate, 'YYYY/MM/DD HH:mm:ss').valueOf();
		},
		parseInternalToMoment: function(stringDate) {
			return moment(stringDate, 'YYYY/MM/DD HH:mm:ss');
		},
		displayDateTime: function(date) {
			return moment(date).format(SOLVNET.getLang("LocaleDateTimeFormat"));
		},
		displayDate: function(date) {
			return moment(date).format(SOLVNET.getLang("LocaleDateFormat"));
		},
		/**
		 * Complète une liste d'erreurs si il y a une incohérence de début & fin d'une plage de date.
		 * @param start en ms depuis epoch
		 * @param end en ms depuis epoch
		 * @param errors array of errors to complete
		 */
		validateDateRange: function(start, end, errors) {
			if (start == null || end == null || start <= end)
				return;
			var format = SOLVNET.getLang("LocaleDateFormat");
			var error = SOLVNET.getLang("InputDateRangeError", moment(start).format(format), moment(end).format(format));
			errors.push(error);
		},
		/**
		 * Complète une liste d'erreurs si il y a une incohérence de début & fin d'une plage d'heure.
		 * @param start en ms depuis epoch
		 * @param end en ms depuis epoch
		 * @param errors array of errors to complete
		 */
		validateTimeRange: function(start, end, errors) {
			if (start == null || end == null || start <= end)
				return;
			var format = SOLVNET.getLang("LocaleTimeFormat");
			var error = SOLVNET.getLang("InputDateRangeError", moment(start).format(format), moment(end).format(format));
			errors.push(error);
		},
		setMomentTimePart: function(date, momentTimePart) {
			return moment(date).set({
				'hours': momentTimePart.hours(),
				'minutes': momentTimePart.minutes(),
				'seconds': momentTimePart.seconds(),
				'milliseconds': momentTimePart.milliseconds()
			});
		},
		setMidnightTime: function(date) {
			if(!date){
				return null;
			}
			return moment(date).startOf('day');
		},
		// same implementation than DateUtils.removeDatePartWithNoOffset in DateUtils.java 
		removeDatePartWithNoOffset: function(date) {
			if(!date){
				return null;
			}
			const d = moment(date);
			const MILLISECONDS_PER_MINUTE = 60 * 1000;
			const MILLISECONDS_PER_HOUR = 60 * MILLISECONDS_PER_MINUTE;
			const timeAt19700101 = new Date(d.hours() * MILLISECONDS_PER_HOUR + 
					d.minutes() * MILLISECONDS_PER_MINUTE +
					d.seconds() * 1000 +
					d.milliseconds());
			timeAt19700101.setTime(timeAt19700101.getTime()+timeAt19700101.getTimezoneOffset()*MILLISECONDS_PER_MINUTE);
			return moment(timeAt19700101);
		},
		/**
		 * Retourne un tableau contenant toutes les occurences d'une récurrence à partir d'une date données.
		 * 
		 * @param {moment} momentOrigin date d'origine. Non modifiée par la fonction
		 * @param {moment} recurrenceStartMoment date de début de la récurrence
		 * @param {moment} recurrenceEndMoment date de fin de la récurrence
		 * @param {Number} recurrencePeriod délai entre 2 occurences
		 * @param {String} recurrenceType type de récurrence (workingDays, weeks ou months)
		 * @param {Array} workedDays tableau des jours travaillés. A l'indice 0, true si le dimanche est travaillé false sinon. A l'indice 1, true si le lundi est travaillé, false sinon...
		 * @returns un tableau contenant toutes les occurences d'une récurrence à partir d'une date données
		 */
		getOccurences: function(momentOrigin, recurrenceStartMoment, recurrenceEndMoment, recurrencePeriod, recurrenceType, workedDays) {
			const result = [];
			let nextOccurence;
			switch (recurrenceType) {
				case 'months':
					/*
					 * Pas possible d'ajouter X mois à nextOccurence à chaque tour de boucle. Il faut Toujours partir de la date d'origine.
					 * Exemple:
					 *     Date d'origine: 31 Janvier 2023
					 *     Ajouter un mois donnera le 28 février 2023
					 *     Ajouter encore un mois donnerai le 28 mars 2023 alors qu'on aurait espéré le 31 mars.
					 *     Ajouter 2 mois à la date d'origine donnera bien le 31 mars.
					 */
					let iteration = 1;
					nextOccurence = moment(momentOrigin).add(iteration * recurrencePeriod, 'M');
					while (recurrenceEndMoment.isSameOrAfter(nextOccurence, 'day')) {
						if (nextOccurence.isAfter(recurrenceStartMoment)) {
							result.push(moment(nextOccurence)); // copie du moment
						}
						nextOccurence = moment(momentOrigin).add(++iteration * recurrencePeriod, 'M');
					}
					return result;
				case 'weeks':
					nextOccurence = moment(momentOrigin).add(recurrencePeriod, 'w');
					while (recurrenceEndMoment.isSameOrAfter(nextOccurence, 'day')) {
						if (nextOccurence.isAfter(recurrenceStartMoment)) {
							result.push(moment(nextOccurence)); // copie du moment
						}
						nextOccurence = moment(nextOccurence).add(recurrencePeriod, 'w');
					}
					return result;
				case 'workingDays':
					nextOccurence = UTILS.datetime.getNextNthWorkedDay(momentOrigin, workedDays, recurrencePeriod);
					while (recurrenceEndMoment.isSameOrAfter(nextOccurence, 'day')) {
						if (nextOccurence.isAfter(recurrenceStartMoment)) {
							result.push(moment(nextOccurence)); // copie du moment
						}
						nextOccurence = UTILS.datetime.getNextNthWorkedDay(nextOccurence, workedDays, recurrencePeriod);
					}
					return result;
				default:
					throw new Error('Unexpected recurrence type: ' + recurrenceType);
			}
		},
		/**
		 * Renvoie le N ème jour travaillé après la date de référence.
		 * 
		 * @param {moment} momentDate date de référence. Non modifiée par la fonction
		 * @param {Array} workedDays tableau des jours travaillés. A l'indice 0, true si le dimanche est travaillé false sinon. A l'indice 1, true si le lundi est travaillé, false sinon...
		 * @param {Number} dayNumber le nième jour travaillé souhaité
		 * @returns la date du nième jour travaillé suivant la date de référence
		 */
		getNextNthWorkedDay: function(momentDate, workedDays, dayNumber) {
			let workedDaysNumber = 0;
			let copyMoment = moment(momentDate);
			while (workedDaysNumber < dayNumber) {
				copyMoment.add(1, 'd');
				if (workedDays[copyMoment.isoWeekday() % 7] === true) { // in Moment, Monday is 1 and Sunday is 7. We want Monday = 1 and Sunday = 0
					workedDaysNumber += 1;
				}
			}
			return copyMoment;
		}
	},
	date: {
		formatInternal: function(date) {
			return moment(date).format('YYYY/MM/DD');
		},
		parseInternal: function(stringDate) {
			return moment(stringDate, 'YYYY/MM/DD').valueOf();
		},
		parseInternalToMoment: function(stringDate) {
			return moment(stringDate, 'YYYY/MM/DD');
		},
		formatMomentToDay: function(moment) {
			return moment.format('YYYYMMDD');
		}
	},
	time: {
		formatInternal: function(date) {
			return moment(date).format('HH:mm:ss');
		},
		parseInternal: function(stringDate) {
			return moment(stringDate, 'HH:mm:ss').valueOf();
		},
		parseInternalToMoment: function(stringDate) {
			return moment(stringDate, 'YYYY/MM/DD');
		}
	},
	bytes : {
		getFormatedSize: function(sizeInBytes) {
			// 1 073 741 824 = 1024 * 1024 * 1024
			if (sizeInBytes >= 1073741824)
				return Math.floor(sizeInBytes / 1073741824) + SOLVNET.getLang("CommonAttachmentUnitGigaBytes");
			// 1 048 576 = 1024 * 1024
			if (sizeInBytes >= 1048576)
				return Math.floor(sizeInBytes / 1048576) + SOLVNET.getLang("CommonAttachmentUnitMegaBytes");
			if (sizeInBytes >= 1024)
				return Math.floor(sizeInBytes / 1024) + SOLVNET.getLang("CommonAttachmentUnitKiloBytes");
			return Math.floor(sizeInBytes) + SOLVNET.getLang("CommonAttachmentUnitBytes");
		}
	},
	units : {
		volumes: [
			{name: 'l', coefBase: 1000000},
			{name: 'cl', coefBase: 10000},
			{name: 'ml', coefBase: 1000},
			{name: 'mm3', coefBase: 1},
			{name: 'cm3', coefBase: 1000},
			{name: 'm3', coefBase: 1000000000}
		],
		getVolume: function(value) {
			return UTILS.math.divide(value.valueAsMm3, UTILS.units.volumes[value.unitId].coefBase);
		},
		weights: [
			{name: 'mg', coefBase: 1},
			{name: 'cg', coefBase: 10},
			{name: 'dg', coefBase: 100},
			{name: 'g', coefBase: 1000},
			{name: 'kg', coefBase: 1000000}
		],
		getWeight: function(value) {
			return UTILS.math.divide(value.valueAsMg, UTILS.units.weights[value.unitId].coefBase);
		}
	},
	math : {
		mult: function(a, b) {
			return (UTILS.math.isNumber(a) && UTILS.math.isNumber(b)) ? (a * b) : null;
		},
		divide: function(a, b) {
			return (UTILS.math.isNumber(a) && UTILS.math.isNumber(b) && b !== 0) ? (a / b) : null;
		},
		add: function(a, b) {
			return (UTILS.math.isNumber(a) || UTILS.math.isNumber(b)) ? ((a || 0) + (b || 0)) : null;
		},
		sum : function() {
			var s;
			for(var x=0;x < arguments.length;x++) {
				var v = arguments[x];
				if(UTILS.math.isNumber(v)) {
					// Ici, v  est un chiffre.
					if(s) {
						// s supérieur ou égale à 0 , on y a ajoute v.
						s += v;
					} else {
						// s est soit égale à 0, soit undefined ou null => on peut directement affecter v.
						s = v;
					}
				}
			}
			return s;
		},
		cumulPct: function(pct1, pct2, pct3) {
			// 1 - (1 - pct1 / 100) * (1 - pct2 / 100) * (1 - pct3 / 100)
			if (!UTILS.math.isNumber(pct1) && !UTILS.math.isNumber(pct2) && !UTILS.math.isNumber(pct3))
				return null;
			var result = 1.0;
			if (UTILS.math.isNumber(pct1))
				result *= (1 - pct1 / 100);
			if (UTILS.math.isNumber(pct2))
				result *= (1 - pct2 / 100);
			if (UTILS.math.isNumber(pct3))
				result *= (1 - pct3 / 100);
			return 100 - 100 * result;
		},
		isNumber: function(v) {
			return typeof v === 'number' && ! isNaN(v);
		},
		sumMult: function(v1, v2, v3, factor) {
			if ((!UTILS.math.isNumber(v1) && !UTILS.math.isNumber(v2) && !UTILS.math.isNumber(v3))
					|| !UTILS.math.isNumber(factor))
				return null;
			if (factor === 0)
				return factor;
			var result = 0;
			if (v1 != null)
				result += v1;
			if (v2 != null)
				result += v2;
			if (v3 != null)
				result += v3;
			return result * factor;
		},
		netPrice: function(price, units, valDiscount, pctDiscount) {
			// (price - units * valDiscount) * (1 - pctDiscount / 100)
			if (! price)
				return undefined;
			var result = price * 1.0;
			if (valDiscount)
				result -= valDiscount * (units ? units : 1);
			if (pctDiscount)
				result *= (1 - pctDiscount / 100);
			return result;
		},
		netCost: function (qty, dis, userPrice, calcPrice) {
			// (qty - dis) * (userPrice or calcPrice)
			if ((!UTILS.math.isNumber(qty) && !UTILS.math.isNumber(dis))
					|| (!UTILS.math.isNumber(userPrice) && !UTILS.math.isNumber(calcPrice)))
				return null;
			var quantity = (!UTILS.math.isNumber(qty) ? 0 : qty) - (!UTILS.math.isNumber(dis) ? 0 : dis);
			var price = (!UTILS.math.isNumber(userPrice) ? calcPrice : userPrice);
			return quantity * price;
		}
	},
	aggregators: { // Ne pas ajouter d'entrée ici car c'est une énumération correspondant aux IDataAggregator côté Java
		min: {
			aggregate: function(total, value) {
				if (total === null)
					return value;
				if (value === null)
					return total;
				var compare = UTILS.object.compare(total, value);
				return (compare > 0) ? value : total;
			}
		},
		max: {
			aggregate: function(total, value) {
				if (total === null)
					return value;
				if (value === null)
					return total;
				var compare = UTILS.object.compare(total, value);
				return (compare < 0) ? value : total;
			}
		},
		sum: {
			start: function() {return 0;},
			aggregate: function(total, value) {
				if (typeof value === 'boolean')
					return total + (value ? 1 : 0);
				// Conforme 1.6, Ici, l'aggregate considère le Null , comme un 0 (voir SumAggregator)
				return total + (value === null ? 0 : value);
			}
		},
		count: {
			start: function() {return 0;},
			aggregate: function(total, value) {
				return total + (value === null ? 0 : 1);
			}
		},
		avg: {
			start: function() {return [0, 0];},
			aggregate: function(total, value) {
				if (value != null) {
					total[0] += 1; // count
					total[1] += value; // sum
				}
				return total;
			},
			finish: function(total) {
				if (total[0] === 0)
					return null; // vide
				return total[1] / total[0]; // moyenne
			}
		},
		distinctsum: {
			start: function() {return [];}, // empty set
			aggregate: function(total, value) {
				if (value != null)
					UTILS.array.addIfNotFound(total, value);
				return total;
			},
			finish: function(values) {
				var total = 0;
				for (var i = 0; i < values.length; i++) {
					total += values[i];
				}
				return total;
			}
		},
		distinctcount: {
			start: function() {return [];}, // empty set
			aggregate: function(total, value) {
				if (value != null)
					UTILS.array.addIfNotFound(total, value);
				return total;
			},
			finish: function(values) {
				return values.length;
			}
		},
		distinctavg: {
			start: function() {return [];}, // empty set
			aggregate: function(total, value) {
				if (value != null)
					UTILS.array.addIfNotFound(total, value);
				return total;
			},
			finish: function(values) {
				var total = 0;
				for (var i = 0; i < values.length; i++) {
					total += values[i];
				}
				return values.length === 0 ? null : (total / values.length);
			}
		},
		repeated: {
			start: function() {return false;}, // nothing yet
			aggregate: function(total, value) {
				if (!total)
					return [value]; // first result
				var compare = UTILS.object.compare(total[0], value);
				if (compare !== 0)
					total[0] = null; // return null if 2 different values are found
				return total;
			},
			finish: function(total) {
				if(total === false) {
					return null;
				}
				return total[0];
			}
		},
		rowcount: {
			start: function() {return 0;},
			aggregate: function(total, value) {
				return total + 1;
			}
		},
	},
	files : {
		isImageFile: function(name) {
			var nameUC = name.toUpperCase();
			return nameUC.endsWith(".JPG") || nameUC.endsWith(".JPEG") || nameUC.endsWith(".PNG") || nameUC.endsWith(".GIF");
		},
		getSmallFileIcon: function (text) {
			var filename = text.toUpperCase();

			var image;
			if(filename.endsWith(".XLS") || filename.endsWith(".XLSX") || filename.endsWith(".XLSM") || filename.endsWith(".ODS")) {
				image = SOLVNET.getURL('images/files/xls.png');
			} else if(filename.endsWith(".DOC") || filename.endsWith(".DOCX") || filename.endsWith(".DOCM") || filename.endsWith(".ODT")) {
				image = SOLVNET.getURL('images/files/doc.png');
			} else if(filename.endsWith(".PPT") || filename.endsWith(".ODP") || filename.endsWith(".PPS") || filename.endsWith(".PPTX") || filename.endsWith(".PPTM") || filename.endsWith(".PPSX")) {
				image = SOLVNET.getURL('images/files/ppt.png');
			} else if(filename.endsWith(".PDF")) {
				image = SOLVNET.getURL('images/files/pdf.png');
			} else if (filename.endsWith(".MP4") || filename.endsWith(".WMV") || filename.endsWith(".MPG") || filename.endsWith(".MPEG") || filename.endsWith(".MPEG4") || filename.endsWith(".MOV") || filename.endsWith(".AVI") || filename.endsWith(".3GP") || filename.endsWith(".MKV") || filename.endsWith(".FLV") || filename.endsWith(".WEBM")) {
				image = SOLVNET.getURL('images/files/video.png');
			} else {
				image = SOLVNET.getURL('images/files/document.png');
			}

			return $('<img />').attr('src', image).css('width', '16px');
		},
		dataURItoBlob: function(dataURL) {
			var BASE64_MARKER = ';base64,';
			var parts, contentType, raw;

			if (dataURL.indexOf(BASE64_MARKER) === -1) {
				parts = dataURL.split(',');
				contentType = parts[0].split(':')[1];
				raw = decodeURIComponent(parts[1]);
				return new Blob([ raw ], {
					type : contentType
				});
			}

			parts = dataURL.split(BASE64_MARKER);
			contentType = parts[0].split(':')[1];
			raw = window.atob(parts[1]);
			var rawLength = raw.length;
			var uInt8Array = new Uint8Array(rawLength);
			for (var i = 0; i < rawLength; ++i) {
				uInt8Array[i] = raw.charCodeAt(i);
			}
			return new Blob([ uInt8Array ], {
				type : contentType
			});
		},
		/**
		 * Récupère les données EXIF d'une image.
		 * 
		 * @param {*} img un élément <img />
		 * @returns une deferred contenant les données EXIF de l'image
		 */
		getEXIFData: (img) => {
			const result = $.Deferred();
			EXIF.getData(img, function() {

				const exifData = {};

				function getFormatedDate(exifDate) {
					if (!exifDate)
						return undefined;
					return moment(exifDate.replace(':', '-').replace(':', '-')).format('L LTS');
				}

				function getFormatedGPSInfo(gps) {
					function formatCoordinate(coordinate, cardinalPoint) {
						return coordinate[0] + '°' + coordinate[1] + "'" + coordinate[2] + '"' + cardinalPoint; 
					}
					if (!gps || !gps.lat || !gps.lon)
						return undefined;
					return formatCoordinate(gps.lat, gps.latDirection) + ' ' + formatCoordinate(gps.lon, gps.lonDirection);
				}

				const make = EXIF.getTag(this, 'Make'),
					model = EXIF.getTag(this, 'Model'),
					createDate = getFormatedDate(EXIF.getTag(this, 'DateTime')),
					gpsLat = EXIF.getTag(this, 'GPSLatitude'),
					gpsLatDirection = EXIF.getTag(this, 'GPSLatitudeRef') || 'N',
					gpsLon = EXIF.getTag(this, 'GPSLongitude'),
					gpsLonDirection = EXIF.getTag(this, 'GPSLongitudeRef') || 'W',
					gps = getFormatedGPSInfo({ lat: gpsLat, latDirection: gpsLatDirection, lon: gpsLon, lonDirection: gpsLonDirection});

				exifData.make = make;
				exifData.model = model;
				exifData.createDate = createDate;
				exifData.gps = gps;
				
				if (!!gps) {
					const lat = UTILS.geo.convertDMStoDD(gpsLat[0], gpsLat[1], gpsLat[2], gpsLatDirection);
					const lon = UTILS.geo.convertDMStoDD(gpsLon[0], gpsLon[1], gpsLon[2], gpsLonDirection);
					const [x, y] = UTILS.geo.lonLatToLambert([lon, lat]);
					
					exifData.x = x;
					exifData.y = y;
					exifData.lon = lon;
					exifData.lat = lat;
				}

				result.resolve(exifData);
			});
			return result;
		}
	},
	users: {
		displayName: function(user) {
			if (!user.firstName && !user.lastName)
				return '';
			return [user.firstName, user.lastName].join(' ');
		}
	},
	tree : {
		/**
		 * Cette fonction calcule le chemin de 'caption' pour le noeud TreeNode (max 50 caractères )
		 * A +-B
		 *   |-C
		 *
		 * Pour B => A/B
		 * Pour C => A/C
		 *@param mapOfAllTreeNodeById Map des noeuds par id.
		 *@param treeNode Node dont on souhaite calculer le chemin
		 *@return un chemin de caption de node. (max 50 caractères )
		 */
		captionPath: function(mapOfAllTreeNodeById, treeNode) {
			var node = treeNode;
			if (!node)
				return "erreur";
			var s = node.caption;
			while (!!(node = mapOfAllTreeNodeById[node.parentId])) {
				s = node.caption + " / " + s;
			}

			if (s.length > 50) {
				s = s.substring(0, 22) + "..." + s.substring(s.length - 23, s.length);
			}

			return s;
		},
		listCaptionPaths: function(mapOfAllTreeNodeById, nodes) {
			var captions = [];
			nodes.forEach(function(treeNode) {
				captions.push({
					id:treeNode.id,
					caption: UTILS.tree.captionPath(mapOfAllTreeNodeById, treeNode)
				});
			});
			return captions;
		},
		/**
		 * @param options un tableau de node : [... {id: , parentId:, depth:, ...  }
		 * @return [ {id: , parentId: , children: [{...}, ...] , ... }, ...]
		 */
		buildTreeFromList: function(options) {
			var roots = [];
			var nodeByParentId = {};

			options.forEach(function(option) {
				if(! option.parentId) {
					roots.push(option);
				} else {
					var children = nodeByParentId[option.parentId];
					if(! children) {
						children = [];
						nodeByParentId[option.parentId] = children;
					}
					children.push(option);
				}
			});


			options.forEach(function(option) {
				option.children = nodeByParentId[option.id];
				if (option.children) {
					option.children = option.children.filter(function(node) {
						return node.depth > option.depth; // Pour éviter les récursions infinies si un objet est son propre parent (cf packaging)
			});
				}
			});

			return roots;
		},
		/** Obtenir le noeud d'un arbre en partant d'un id pour un niveau de profondeur données*/
		findTreeNodeAtLevelForAnId: function(mapOfAllOptionsById, id, level) {
			if (!id)
				return null;
			var treeNode = mapOfAllOptionsById[id];
			do {
				if (! treeNode)
					return null;
				if (treeNode.depth === level) {
					return treeNode;
				} else if (treeNode.depth < level) {
					return null;
				}
			} while (!!(treeNode = mapOfAllOptionsById[treeNode.parentId]));
			return null;
		},
		/**
		 * Cette fonction tri un arbre sur la base de sa parenté.
		 * Il garde l'ordre initial. C'est à dire que si vous souhaitez aussi l'ordre alphabétique, il faut que vous triez via l'ordre alphabétique
		 * avant d'appeler cette méthode.
		 * @param srcValues Tableau des noeuds sources
		 * @param dstValue Table des noeuds de destinations
		 * @param optionalParentId est utilisé pour la récursivité. Il est optionel pour l'appel initial
		 * sauf si vous souhaitez garder qu'une sous-branche de l'arbre.
		 * @return Tableaux des noeuds de destination
		 */
		orderHierarchyList: function (srcValues, dstValues, optionalParentId) {
			var count = srcValues.length;
			for (var index = 0; index < count; index++) {
				var value = srcValues[index];
				if ((!optionalParentId && value.depth === 1) || optionalParentId === value.parentId) {
					dstValues.push(value);
					UTILS.tree.orderHierarchyList(srcValues, dstValues, value.id);
				}
			}
			return dstValues;
		}
	},
	fields: {
		PREVIOUS_SUFFIX:"_nm1",
		getOptionsCaptionsFromIds: function (field, options, idsArray) {
			var captions = '';
			var arrayOfCaptions = [];

			if (options && options.length > 0
					&& idsArray && idsArray.length > 0) {
				idsArray.forEach(function(id) {
					var option = UTILS.array.findBy(options, field.valueProperty || 'value', isNaN(id) ? id : parseInt(id));
					if (option)
						arrayOfCaptions.push(option[field.titleProperty || 'title']);
				});
				captions = arrayOfCaptions.join(', ');
			}

			return captions;
		},
		applyPreviousCaption: function (fields, fieldsRights) {
			if(! fieldsRights)
				return; // Probablement en paramétrage, il n'y aura pas de libellé à corriger.

			return fields.forEach(function(field) {
				var name = field.name;
				if(name.endsWith(UTILS.fields.PREVIOUS_SUFFIX)) {
					name = name.substr(0,name.length - UTILS.fields.PREVIOUS_SUFFIX.length);
					var right =  UTILS.array.findBy(fieldsRights, 'name', name);
					if(right && right.caption) {
						field.caption =right.caption + SOLVNET.getLang('LinearPreviousSuffix');
					}
				}
			});
		},
		createPreviousFieldsFrom: function (fields, createForCard, excludedFields) {
			return (!!excludedFields ? excludedFields(fields) : fields).map(function(field) {
				var previousField = $.extend(true, {}, field);
				previousField.name += UTILS.fields.PREVIOUS_SUFFIX;
				previousField.caption += SOLVNET.getLang('LinearPreviousSuffix');
				previousField.noMarketAccess = true;
				previousField.readonly = true;
				previousField.nullable = true;
				if(previousField.subObjectProperty) {
					previousField.subObjectProperty = "previous." + previousField.subObjectProperty;
				} else {
					previousField.subObjectProperty = "previous";
					if (createForCard) {
						previousField.propertyType = previousField.type;
						previousField.type = "subobject";
					}
				}
				return previousField;
			});
		},
		getFieldReadonly: function (wrapper, type, value) {
			// Types: checkbox, input, textarea
			switch (type) {
				case 'text':
					wrapper.append($('<span/>').text(value));
					break;
				case 'checkbox':
					wrapper.append($(value ? '<i>check_box</i>' : '<i style="color: rgba(0, 0, 0, .54);">check_box_outline_blank</i>')
						.addClass('material-icons')
						.css('display', 'block'));
					break;
				case 'textarea':
					wrapper.append($('<p/>').text(value));
					break;
				default:
			}
		},
		getFieldNullable: function(field) {
			// Utiliser l'info précisée par les champs eux-mêmes si possible
			if (typeof field.nullable !== 'undefined')
				return field.nullable;
			// Pour les champs booléen, on considère qu'ils ne peuvent pas être vide (true ou false)
			if (field.type === 'boolean' || field.type === 'checkboxAMPM')
				return false;
			// Les champs "id", "create_date" et "create_user_id" sont forcément alimentés
			if (field.property === 'id' || field.property === 'createDate' || field.property === 'createUserId')
				return false;
			// Sinon, par défaut, on considère que ça peut être vide car c'est la grande majorité des champs
			return true;
		},
		getFieldAccessRules: function() {
			return {
				Invisible : { access: 0, visible: false, readonly: true , modifiable: false, required: false },
				Fixed     : { access: 1, visible: true , readonly: true , modifiable: false, required: false },
				ReadOnly  : { access: 2, visible: true , readonly: true , modifiable: false, required: false },
				Modifiable: { access: 4, visible: true , readonly: false, modifiable: true , required: false },
				Required  : { access: 5, visible: true , readonly: false, modifiable: true , required: true  }
			};
		},
		injectAccessRule: function(field, accessRule) {
			// Si les access du field sont un tableau
			if (accessRule && field.rights) {
				// On applique à tous les éléments, les nouveaux droits
				if (field.access) {
					field.access = field.access.map(function(a){ return accessRule; });
				} else {
					// Ou on crée le tableau et un objet correspondant au champ
					field.access = [accessRule];
				}
			} else {
				field.access = accessRule;
			}
		},
		replaceAccessByCustomizations: function(field, customizations, accessRules) {
			// Le but est de personnaliser les droits d'accès à un champ suite à un contrôle.
			// Il faut par contre faire à attention pour conserver les libellés et autres infos.
			// - cf bug chez RFD CP : https://support.solvnet.fr:9998/devels/edit/2855
			// - cf bug chez Actiale : https://support.solvnet.fr:9998/devels/edit/2781
			// - cf bug chez Eckes : https://support.solvnet.fr:9998/devels/edit/2951
			function customize(name, access) {
				var c = customizations[name];
				if (c && c.access) {
					// accessRules provient de UTILS.fields.getFieldAccessRules
					$.extend(access, accessRules[c.access]);
				}
			}

			if (Array.isArray(field.rights)) {
				// Pour les champs hiérarchiques (centrale, circuit, ...), field.access est un tableau
				// - contenant une entrée pour le champ complet (customers.circuit par exemple)
				// - contenant aussi une entrée pour chaque niveau (customers.circuit_1_id, customers.circuit_2_id par exemple)
				// Le but est d'injecter les droits personnalisés de chaque entrée du tableau
				var originAccess = field.access || [];
				field.access = field.rights.map(function(rightName, idx) {
						// Droit d'origine.
					var access = UTILS.array.findByName(originAccess, rightName);
					// Non trouvé = Invisible
					if (! access)
						access = $.extend({name: rightName}, accessRules['Invisible']);
					// Droit customisé.
					customize(rightName, access);
					return access;
				});
			} else {
				// Pour les champs "simples" (enseigne, surface, ...), field.access est un objet
				// Le but est d'injecter les droits personnalisés du champ (customers.tradename_id par exemple)
				customize(field.name, field.access);
			}
		},
		getFieldForFormOrGrid: function(field, fieldOptions) {
			for (var o in fieldOptions) {
				field[o] = fieldOptions[o];
			}
			return field;
		},
		getFieldOptionsForGridOrForm: function(toGrid, toForm, gridOptions, formOptions) {
			return toGrid ? gridOptions : (toForm ? formOptions : {});
		},
	},
	form: {
		selectToIds: function(select) {
			var result = $(select).val();
			if (!result)
				return undefined;
			return result.map(function(idString) {
				return parseInt(idString);
			});
		},
		/**
		 * Serialization d'un objet dans un formulaire FormData (le code est probablement spécifique pour Webmotion).
		 * Attention, si vous réutilisez cette fonction, elle ne gère les tableaux d'objets : exemple {data:[{id:1, name:'toto'}, {id:2, name:'tata'}]}
		 */
		appendFormData: function (formData, name, values){
			var key;
			if (! values) {
				formData.append(name, '');
			} else if (Array.isArray(values)) {
				values.forEach(function(data) {
					formData.append(name, data);
				});
			} else if (typeof values === 'object') {
				for (key in values) {
					if (! values.hasOwnProperty(key) || values[key] === undefined)
						continue;
					if (typeof values[key] === 'object')
						UTILS.form.appendFormData(formData, name + '.' + key, values[key]);
					else
						formData.append(name + '.' + key, values[key]);
				}
			} else {
				formData.append(name, values);
			}
		},
		/**
		 * Helper temporaire  pour les composant multiselect, afin d'éviter d'être prisonnier des div.scrollables
		 * On affiche le dropDown en position fixed
		 * On s'assure que le celui-ci ne déborde pas entre les boites  pour éviter un problème de recouvrement par des boites qui n'ont pas le même contexte z-index.
		 * @this doit être sur le composant select
		 */
		multiselectDropDownHelper: function() {
			var select = $(this);
			var container = select.parent().find('.multiselect-container');
			var ref = select.parent().find('div.btn-group');
			var offset = ref.offset();

			container.css('position', 'fixed');
			container.css('left', offset.left);

			// On prend la largeur du composant.
			container.css('width', ref.width());

			// On positionne la dropdown en bloquant sur le bas de box si on l'atteint ou on la dépasse.
			var top = offset.top + ref.height();
			var containerHeight =  container.height();


			var boxContainer = select.parents(".box");
			if(boxContainer.length) {
				var bottomBox = boxContainer.offset().top + boxContainer.height();
				if((top + Math.min(400,containerHeight)) < bottomBox) {
					container.css('top', top);
				} else {
					container.css('top', Math.max(0, bottomBox - Math.min(400,containerHeight)));
				}
				container.css('zIndex', 65535);
			} else {
				// En dehors d'un box, on vérifie qu'on ne sort pas de l'écran.
				container.css('top', top);
				if(top + 400 > $(document).height()) {
					setTimeout(function() {
						container.css('top', top - container.height());
					}, 0);
				}
				container.css('zIndex', 65535);
			}

			function hideDropDown(event) {
				if (container.find(event.target).length === 0) {
					ref.removeClass('open');
					container.parents().each(function() {
						$(this).off('scroll', hideDropDown);
					});
				}
			}

			container.parents().each(function() {
				$(this).on('scroll', hideDropDown);
			});
		},
		/**
	 	 * Encapsule une action onclick pour éviter les doubles click.
	 	 */
		doubleClickStop: function(action) {
			var lastClickTime;
			return function(event) {
				var clickTime = Date.now();
				if(! lastClickTime || (clickTime - lastClickTime) > 500) {
					lastClickTime = clickTime;
					action(event);
				}
			};
		},
		availabilitiesForm: function(field, model, $domParent, editable, onChangeCallback) {
			let el = $('<div class="bbm-availabilities"/>');
		
			$('<a />')
				.attr('class', 'button-availabilities')
				.attr('href', '#')
				.attr('target', '_self')
				.attr('title', model.name)
				.data('model', model)
				.append($('<span class="material-icons">event_available</span>'))
				.appendTo(el);
			$('<ul class="bbm-availabilities-days" />').appendTo(el);
	
			/** Les disponibilités sont sous ce format là : 
					[
						{"dayId": 2, "availabilities": [{"startTime": 14400000, "endTime": 25200000}]},
						{"dayId": 3, "availabilities": [{"startTime": 14400000, "endTime": 25200000}, {"startTime": 61200000, "endTime": 75600000}]}
					]
			 */
			UTILS.form.buildAvailabilities(field, model, el.find('ul'));
			return el.appendTo($domParent).on('click', function() {
				var datas = {
					availabilitiesByDay: model.availabilitiesByDay,
					objectCaption: model.name,
					editable: editable,
				};
				$('<div />').materialPopinAvailabilities(datas, function(newAvailabilitesByDay) {
					model.availabilitiesByDay = newAvailabilitesByDay;
					el.data('availabilitiesByDay', newAvailabilitesByDay);
					if (onChangeCallback)
						onChangeCallback(field, el);
				});
			});
		}, 
		buildAvailabilities: function (field, model, ul) {
			function addDay(caption, okAM, okPM, wrapper) {
				var $dayList = wrapper;
				var $day = $('<li class="day" />').text(caption).appendTo($dayList);
				// on ajoute les images des disponibilités
				if(!okAM && !okPM)
					$day.addClass("bbm-availabilities-not-available");
				if (!okAM && okPM)
					$day.addClass("bbm-availabilities-available-afternoon");
				if (okAM && !okPM)
					$day.addClass("bbm-availabilities-available-morning");
				if (okAM && okPM)
					$day.addClass("bbm-availabilities-available-all-day");
			}
			
			let availabilities = model.availabilitiesByDay || [];
			for (let i = 0; i < 7; i++) {
				const idx = (field.firstDayOfWeek + i) % 7;
				let okAM = false, 
					okPM = false;
				
				let dayAvailability = availabilities.find(e => e['dayId'] === idx);
				if (!!dayAvailability) {
					okAM = dayAvailability.availabilities.length === 2 || dayAvailability.availabilities[0].endTime <= 39600000;
					okPM = dayAvailability.availabilities.length === 2 || dayAvailability.availabilities[0].endTime > 39600000;
				}
				addDay(field.shortDays[idx].charAt(0), okAM, okPM, ul);
			}
		},
		linkPeriodPickers: function(startDatePicker, endDatePicker, startTimePicker, endTimePicker, minuteExtraDuration) {
			function checkPickersPair(startPicker, endPicker) {
				const start = startPicker.data("DateTimePicker").date().startOf('day');
				let end = endPicker.data("DateTimePicker").date().startOf('day');
				// Vérification
				if (start.isSameOrAfter(end)) {
					end = moment(start).add(minuteExtraDuration, 'minutes');

					// Réinjection des valeurs dans les pickers
					startPicker.data("DateTimePicker").date(start);
					endPicker.data("DateTimePicker").date(end);
				}
			}

			function check(dateAvailable, timeAvailable) {
				if (dateAvailable && timeAvailable) {
					// Récupération des pickers
					const sd = startDatePicker.data("DateTimePicker").date().startOf('day');
					const st = startTimePicker.data("DateTimePicker").date().year(sd.year()).month(sd.month()).date(sd.date());
					const ed = endDatePicker.data("DateTimePicker").date().startOf('day');
					let et = endTimePicker.data("DateTimePicker").date().year(ed.year()).month(ed.month()).date(ed.date());

					// Vérification
					if (st.isSameOrAfter(et)) {
						et = moment(st).add(minuteExtraDuration, 'minutes');

						// Réinjection des valeurs dans les pickers
						startDatePicker.data("DateTimePicker").date(st);
						startTimePicker.data("DateTimePicker").date(st);
						endDatePicker.data("DateTimePicker").date(et);
						endTimePicker.data("DateTimePicker").date(et);
					}
				}
				else if (dateAvailable) {
					checkPickersPair(startDatePicker, endDatePicker);
				}
				else if (timeAvailable) {
					checkPickersPair(startTimePicker, endTimePicker);
				}
			}

			const dateAvailable = UTILS.object.isDefinedNotNullNotFalse(startDatePicker) && UTILS.object.isDefinedNotNullNotFalse(endDatePicker);
			const timeAvailable =  UTILS.object.isDefinedNotNullNotFalse(startTimePicker) && UTILS.object.isDefinedNotNullNotFalse(endTimePicker);

			if (dateAvailable) {
				startDatePicker.on('dp.change dp.hide', _event => check(dateAvailable, timeAvailable));
				endDatePicker.on('dp.change dp.hide', _event => check(dateAvailable, timeAvailable));
			}
			if (timeAvailable) {
				startTimePicker.on('dp.change dp.hide', _event => check(dateAvailable, timeAvailable));
				endDatePicker.on('dp.change dp.hide', _event => check(dateAvailable, timeAvailable));
			}
		}
	},
	grid: {
		/**
		* Fonction permettant de marquer les lignes de détail comme étant modifiées après l'execution d'un controle
		* @param row : la ligne à marquer comme modifié si besoin
		* @param rowContext : le context de la ligne
		* @returns : rien
		*/
		updateRowModified: function(rowContext, row) {
			if (rowContext.modifications.includes(row)) {
				row.gridModifiedTimestamp = Date.now();
				return true;
			}
			return false;
		},
		/** Ajuster les droits "accesses", alimentés par exemple par contrôles LoadDetail, sur les colonnes "columns" */
		applyAccess: function(columns, accesses) {
			if (! accesses)
				return;
			columns.forEach(function(col) {
				if (accesses[col.name]) {
					switch (accesses[col.name]) {
						case 'Invisible':
							col.hidden = true;
							break;
						case 'Required':
							col.required = true;
							col.editable = true;
							break;
						case 'Modifiable':
							col.editable = true;
							break;
						default:
							break;
					}
				}
			});
		}
	},
	javaFormat: {
		/**
		 * permet de modifier le formatage d'une date du format Java en format moment
		 * map : contient la traduction pour le formatage -> utilisé dans la fonction apply
		 * apply: applique le formatage -> utilisé dans la fonction convert
		 * convert : parcours la chaine à formater (fonction principale)
		 * test: lance une batterie de test sur différent format de date
		 */
		map: {
			d: 'D',
			dd: 'DD',
			D: 'DDD',
			y: 'YYYY',
			yy: 'YY',
			yyy: 'YYYY',
			yyyy: 'YYYY',
			Y: 'gggg',
			YY: 'gg',
			YYYY: 'gggg',
			a: 'A',
			S: 'SSS',
			SS: 'SSS',
			SSS: 'SSS',
			E: 'ddd',
			EE: 'ddd',
			EEE: 'ddd',
			EEEE: 'dddd',
			w: 'W',
			ww: 'WW',
			Z: 'ZZ',
			X: 'ZZ',
			XX: 'ZZ',
			XXX: 'Z',
			u: 'E'
		},
		apply: function(formatString, startIndex, endIndex, openBracket, result) {
			var tempString = formatString.substring(startIndex, endIndex);
			// on vérifie d'abord si tempString est une apostrophe
			if (tempString === '\'') {
					tempString = openBracket ? '[' : ']';
			} else if (!openBracket // on a une apostrophe d'ouvert donc tout ce qu'il y a jusqu'à la prochaine apostrophe ne doit pas être traduit
					&& UTILS.javaFormat.map[tempString]) { // et on vérifie si tempString est dans la map des conversions
					tempString = UTILS.javaFormat.map[tempString];
			}
			return result.concat(tempString);
		},
		convert: function(dateFormat) {
			var beginIndex = -1,
				lastChar = null,
				currentChar = "",
				resultDateFormat = "",
				openBracket = false;  // sert à determiner si on ouvre ou on ferme le crochet

			for (var i = 0; i < dateFormat.length; i++) {
				currentChar = dateFormat.charAt(i);
				if (lastChar === null || lastChar !== currentChar) { // on boucle tant que l'on a le meme caractère
					if (beginIndex !== -1) {
						resultDateFormat = UTILS.javaFormat.apply(dateFormat, beginIndex, i, openBracket, resultDateFormat);
					}
					beginIndex = i;
				}
				if (currentChar === '\'')
					openBracket = !openBracket;
				lastChar = currentChar;
			}
			// et on l'appelle une derniere fois pour avoir le dernier caractère
			return UTILS.javaFormat.apply(dateFormat, beginIndex, dateFormat.length, openBracket, resultDateFormat);
		},
		test: function() {
			var dateFormat = 'dd/MM/yyyy',
				newFormat = UTILS.javaFormat.convert(dateFormat),
				date = moment(),
				result = 'Java date format : {0} -> Moment date format : {1}  RESULTAT: {2}';
			window.console.log(SOLVNET.formatMessage(result, [dateFormat, newFormat, date.format(newFormat)]));

			dateFormat = '\'jour\' dd, \'mois\' MM, \'annee\' yyyy';
			newFormat = UTILS.javaFormat.convert(dateFormat);
			window.console.log(SOLVNET.formatMessage(result, [dateFormat, newFormat, date.format(newFormat)]));

			dateFormat = 'd/M/yy';
			newFormat = UTILS.javaFormat.convert(dateFormat);
			window.console.log(SOLVNET.formatMessage(result, [dateFormat, newFormat, date.format(newFormat)]));

			dateFormat = 'dd/MM/yyyy h:m:s a';
			newFormat = UTILS.javaFormat.convert(dateFormat);
			window.console.log(SOLVNET.formatMessage(result, [dateFormat, newFormat, date.format(newFormat)]));

			dateFormat = 'dd/MM/yyyy HH:mm:s';
			newFormat = UTILS.javaFormat.convert(dateFormat);
			window.console.log(SOLVNET.formatMessage(result, [dateFormat, newFormat, date.format(newFormat)]));

			dateFormat = 'dd/MM/yyyy HH:mm:s.SSS';
			newFormat = UTILS.javaFormat.convert(dateFormat);
			window.console.log(SOLVNET.formatMessage(result, [dateFormat, newFormat, date.format(newFormat)]));

			dateFormat = '\'Le "\' EEEE dd MMMM yyyy \'" est le\' u \'er(ème) jour(s) de la semaine\' W'
					+ '\' et le\' D \' jour de \'YYYY';
			newFormat = UTILS.javaFormat.convert(dateFormat);
			window.console.log(SOLVNET.formatMessage(result, [dateFormat, newFormat, date.format(newFormat)]));
		}
	},
	queue: {
		createAsynchroneRunner: function() {
			var queue = [];

			function executeNext() {
				queue[queue.length-1](end);
			}

			function end() {
				// Retire du sommet de la pile.
				queue.pop();

				// Si il en reste au moins 1 , on passe au suivant. setTimeout permet d'éviter le débordement de pile.
				if(queue.length > 0) {
					executeNext();
				}
			}

			return {
				pushRunnable: function(callback) {
					queue.unshift(callback);
					if (queue.length === 1)
						executeNext();
				}
			};
		}
	},
	formula: {
		checkProperties: function(item, url, property) {
			var defer = $.Deferred();
			$.get(
				SOLVNET.getURL(url, {formula: item.properties[property], toDisplayFormat: false})
			).fail(function(error) {
				defer.reject({ properties: [property] });
			}).done(function(convertFormulaResult) {
				item.properties[property] = convertFormulaResult;
				defer.resolve();
			});
			return defer;
		}
	},
	template: {
		/**
		 * @param objectId - Identifiant de l'objet (marché ou vue)
		 * @param propertyTemplates - string du paramétrage du LayoutItemTypes qui contient la liste des templates sélectionnés au paramétrage.
		 * @param templatesMenuEntries - Entrées de menu de template [ {name: 'exporttemplates', text: t, param: t}]
		 * @return Liste des templates sélectionnés.
		 */
		filterTemplate: function(objectId, propertyTemplates, templatesMenuEntries) {
			if (propertyTemplates === undefined || propertyTemplates.length === 0)
				return templatesMenuEntries;

			var selectedTemplates = propertyTemplates.split(",");
			return templatesMenuEntries.filter(function(template) { return selectedTemplates.indexOf(objectId + '/' + template.text) >= 0; });
		},
		/**
		 * @param objectId - Identifiant de l'objet (marché ou vue)
		 * @param templateFiles - tableau de fichier de template.
		 * @param propertyTemplates - string liste de templates sélectionnés dans la configuration ex: item.properties.templates
		 * @param $itemDiv - div du LayoutItemType
		 * @param optionalSuffix string qui permet de catégoriser les entrées (utile uniquement pour l'agenda, frais, activité)
		 */
		initMenuTemplates: function(objectId, templateFiles, propertyTemplates, $itemDiv, optionalSuffix) {
			if (! templateFiles)
				return;

			var entries = [];
			templateFiles.forEach(function(t) {
				entries.push( {name: 'exporttemplates', text: t, param: optionalSuffix ? optionalSuffix + t : t});
			});
			entries = UTILS.template.filterTemplate(objectId, propertyTemplates, entries);
			if (entries.length) {
				entries.sort();
				$itemDiv.trigger('solvnet.exporttemplatesmenulist', [entries]);
			}
		},
		/**
		 * Rafraîchir les exports de templates disponibles
		 * @param object - Clé d'accès à l'objet métier dans $itemDiv.data
		 * @param propertyTemplates - string liste de templates sélectionnés dans la configuration ex: item.properties.templates
		 * @param $itemDiv - div du LayoutItemType, la fonction par du postulat qu'elle trouvera $itemDiv.data('configurationId') & $itemDiv.data(object).templates
		 */
		initMenuTemplatesForConfiguration: function(object, propertyTemplates, $itemDiv, optionalExtraEntries) {
			// Les entrées disponibles
			var entries = [];
			// La sélection du paramétrage (undefined pour toutes disponibles)
			var selectedTemplates = propertyTemplates ? propertyTemplates.split(",") : undefined;
			// La configuration sélectionnée
			var selectedConfigurationId = $itemDiv.data("configurationId");
			$itemDiv.data(object).templates.forEach(function(t) {
				if (t.id === selectedConfigurationId) {
					t.files.forEach(function(f) {
						if (selectedTemplates === undefined || selectedTemplates.length === 0
							|| selectedTemplates.indexOf(t.id + '/' + f) >= 0) {
							entries.push( {name: 'exporttemplates', text: f, param: f });
						}
					});
				}
			});

			if (optionalExtraEntries)
				entries = entries.concat(optionalExtraEntries);

			if (entries.length > 0) {
				entries.sort();
				$itemDiv.trigger('solvnet.exporttemplatesmenulist', [entries]);
			}
			else {
				$itemDiv.trigger('hidecontrol', ['exporttemplates']);
			}
		}
	},
	publication: {
		types: function() {
			return [
				{value: 0, title: SOLVNET.getLang('PublicationNone')},
				{value: 10, title: SOLVNET.getLang('PublicationCustom')},
				{value: 20, title: SOLVNET.getLang('PublicationAll')}
			];
		}
	},
	color: {
		/**
         * Retourne la couleur demandée sous forme HTML :
         * - asHTMLColor(0, 1) renvoie rgb(0,0,0)
         * - asHTMLColor(255, 0.5) renvoie rgba(255,0,0,0.5)
         *
         * @param intColor la couleur RGB (par exemple 0 pour noir)
         * @param opacity valeur entre 0 (invisible) et 1 (opaque) pour jouer sur la transparence
         * @return la couleur correspondante en HTML (par exemple #000000 pour noir ou rgba(r,g,b,opacity)
         */
        asHTMLColor: function asHTMLColor(intColor, opacity) {
			var r = intColor >> 16 & 255, g = intColor >> 8 & 255, b = intColor & 255;
			if (opacity === 1)
				return 'rgb(' + r + ',' + g + ',' + b + ')';
			return 'rgba(' + r + ',' + g + ',' + b + ',' + opacity + ')';
		}
	},
	geo: {
		/**
		 * Convertit des coordonnées en Degrés Minutes Secondes en coordonnées Degrés décimaux.
		 * 
		 * @param {*} degrees 
		 * @param {*} minutes 
		 * @param {*} seconds 
		 * @param {*} direction 'N', 'S', 'E' ou 'W' pour Nord, Sud, Est ou Ouest
		 * @returns les coordonnées en degrés décimaux
		 */
		convertDMStoDD: (degrees, minutes, seconds, direction) => {
			let dd = degrees + minutes / 60 + seconds / (60 * 60);
			const upperCaseDirection = direction.toUpperCase();
			if (upperCaseDirection === 'S' || upperCaseDirection === 'W') {
				dd = dd * -1;
			}
			return dd;
		},
		ROUNDING_OF_THE_EARTHS_RADIUS_KM: 6400,
		/**
		 * Calcule la distance entre deux points.
		 * 
		 * @param {Number} srcLon longitude du premier point en radian
		 * @param {Number} srcLat latitude du premier point en radian
		 * @param {Number} dstLon longitude du second point en radian
		 * @param {Number} dstLat latitude du second point en radian
		 * @returns la distance entre les 2 points en kilomètres, arrondi au dixième
		 */
		computeDistance: (srcLon, srcLat, dstLon, dstLat) => {
			const distance = UTILS.geo.ROUNDING_OF_THE_EARTHS_RADIUS_KM * Math.acos(Math.sin(srcLat) * Math.sin(dstLat) + Math.cos(srcLat) * Math.cos(dstLat) * Math.cos(srcLon - dstLon));
			return parseFloat(distance.toFixed(1));
		},
		/**
		 * Convertit une coordonnée exprimée en degrés en une coordonnée exprimée en radians
		 * @param {Number} degree coordonnée exprimée en degrés
		 * @returns coordonnée exprimée en radians
		 */
		degreeToRad: (degree) => {
			return degree * Math.PI / 180;
		},
		/** Code EPSG de la projection Lambert 2 étendu */
		LAMBERT_2_ETENDU_CODE: 'EPSG:27572',
		/** Retourne la projection Lambert 2 étendu définit pour proj4 */
		getLambertProjection: () => {
			const code = UTILS.geo.LAMBERT_2_ETENDU_CODE;
			let projection = proj4.Proj(code);
			if (!projection) {
				const projectionDefinition = '+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=2200000 +a=6378249.2 +b=6356515 +towgs84=-168,-60,320,0,0,0,0 +pm=paris +units=m +no_defs';
				proj4.defs(code, projectionDefinition);
				projection = proj4.Proj(code);
			}
			return projection;
		},
		/** Retourne la projection WGS84 définit pour proj4 */
		getWGS84Projection: () => proj4.Proj('WGS84'), // pas besoin de la définir, elle est intégrée par défaut
		/**
		 * Convertit des coordonnées Lambert 2 étendu en coordonnées Lon/Lat
		 * @param {Number[]} coordinates tableau à 2 éléments contenant x et y dans la projection Lambert 2 étendu
		 * @returns un tableau à deux éléments contenant lon et lat
		 */
		lambertToLonLat: (coordinates) => {
			const lambertProjection = UTILS.geo.getLambertProjection();
			const WGS84_PROJECTION = UTILS.geo.getWGS84Projection();
			const lonLat = proj4(lambertProjection, WGS84_PROJECTION, coordinates);
			return lonLat;
		},
		/**
		 * Convertit des coordonnées Lon/Lat en coordonnées Lambert 2 étendu
		 * @param {Number[]} coordinates tableau à 2 éléments contenant lon et lat
		 * @returns un tableau à deux éléments contenant x et y
		 */
		lonLatToLambert: (coordinates) => {
			return proj4(UTILS.geo.getLambertProjection(), coordinates);
		}
	}
};
